/* components/ProductsFilters
- Used within collection and search templates

Example
<collection-filters>
    [[collection filters content]]
</collection-filters>
*/

import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CollectionFilters extends ThemeComponent {
    @Ref() details!: HTMLDListElement[];
    private filterToggle = document.querySelector('[data-ref="filterToggle"]') as HTMLButtonElement;
    private open: string = '';
    private _onOpenChange = new SimpleEvent<string>();

    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }

    public changeOpen(open: string) {
        this.open = open;

        // Use the private backing field to dispatch
        this._onOpenChange.dispatch(open);
    }



    init() {
        this.handleDetailsOpen(this.details);
        if (!this.filterToggle) { return; }
        this.$listen(this.filterToggle, 'click', () => {
            this._onOpenChange.dispatch(this.open);
        });
        const urlParams = new URLSearchParams(window.location.search);
        const paginated = urlParams.get('page');

        if (paginated) {
            const target = this.closest('.SALVO_SECTION') as HTMLElement;
            target?.scrollIntoView({ block: "start" });
        }
    }

    private handleDetailsOpen(details: HTMLDListElement[]) {
        for (const detail of details) {
            detail.addEventListener("click", () => {
                for (const sibling of details) {
                    if (detail !== sibling) {
                        sibling.removeAttribute("open");
                    }
                }
            });
        }
    }
}
